
   <template>
  <v-card class="transparent elevation-0 mb-4 ml-2">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout pb-4 row justify-center>
        <v-flex xs6>
          <v-layout wrap mr-1 ml-1 class="layoutTest">
            <v-flex xs12 mt-3>
              <h2 class="m1">{{$translate('STEP_DETAILS')}}</h2>
              <v-text-field
                @input="checkTheData()"
                v-model="_tripForm.name"
                placeholder="Name your trip"
                type="text"
                item-text="label"
                :rules="textRule"
                item-value
                required
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="layoutTest" ml-1 mr-1>
            <v-flex xs6>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedStartDate"
                    label="Start date"
                    append-icon="event"
                    readonly
                    @input="checkTheData()"
                    @change="checkTheData()"
                    v-on="on"
                    outline
                    :rules="textRule"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="nowDate"
                  @change="checkTheData()"
                  v-model="unformattedStartDate"
                  no-title
                  scrollable
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedEndDate"
                    label="End date"
                    append-icon="event"
                    readonly
                    @input="checkTheData()"
                    @change="checkTheData()"
                    v-on="on"
                    outline
                    :rules="textRule"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="nowDate"
                  v-model="unformattedEndDate"
                  no-title
                  @change="checkTheData()"
                  scrollable
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="layoutTest" ml-1 mr-1>
            <v-flex xs6>
              <v-text-field
                type="time"
                slot="activator"
                hint="Input: hh:mm"
                locale="en-us"
                @input="checkTheData()"
                :label="$translate('LINDA_ARRIVAL_LABEL')"
                v-model="_tripForm.ArrivalTime"
                required
                :rules="textRule"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                type="time"
                hint="Input: hh:mm"
                slot="activator"
                @input="checkTheData()"
                :label="$translate('LINDA_DEPARTURE_LABEL')"
                v-model="_tripForm.DepartureTime"
                required
                :rules="textRule"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row class="layoutTest" wrap ml-1 mr-1>
            <v-flex xs9>
              <v-select
                v-model="_tripForm.transportName"
                :items="typesOfTrans"
                item-text="Description"
                required
                @change="checkTheData()"
                :label="$translate('LINDA_TRANSPORT_MODE')"
                item-value="Description"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                v-model="_tripForm.groupSize"
                item-text="Description"
                required
                type="number"
                @input="checkTheData()"
                :label="$translate('LINDA_GROUP_SIZE')"
                :value="3"
                outline
                min="1"
                :rules="groupSizeRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row justify-space-around>
            <v-btn
              round
              class="text-capitalize"
              color="secondary"
              @click="goHome()"
            >{{$translate('BACK')}}</v-btn>
            <v-btn
              round
              :disabled="disableButton"
              class="text-capitalize"
              color="primary"
              @click="setChosenDetails()"
            >{{$translate('NEXT')}}</v-btn>
          </v-layout>
        </v-flex>
        <v-dialog v-model="errorDialog" max-width="290" persistent>
          <v-card>
            <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
            <v-card-text>
              <p>{{$translate('LINDA_FILL_REQUIRED')}}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                round
                class="text-capitalize"
                color="primary"
                @click="errorDialog = false"
              >{{$translate('NEXT')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-form>
    <v-dialog v-model="wrongTimeInput" max-width="320" persistent content-class="dialog_class">
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>
          <h3 v-if="errorText === 1">
            {{$translate('INVALID_ENDDATE')}}
            <br />
          </h3>
          <h3 v-if="errorText === 2">
            {{$translate('INVALID_ENDTIME')}}
            <br />
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            round
            @click="wrongTimeInput= false"
          >{{$translate('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import BaseObject from "../objects/BaseObject";
import BaseComponent from "./base/BaseComponent.vue";
import { ui_helpers } from "../shared/ui_helpers.js";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],

  name: "CustomerSelectionDetails",
  props: {
    eventDate: ""
  },

  computed: {
    ...mapGetters({
      _webStep: "getWebStepId",
      _tripForm: "getTripForm"
    }),

    formattedStartDate() {
      return this.formatDate(this.unformattedStartDate);
    },
    formattedEndDate() {
      return this.formatDate(this.unformattedEndDate);
    }
  },

  data: () => ({
    //form
    disableButton: true,

    nowDate: new Date().toISOString().slice(0,10),
    errorText: 0,
    wrongTimeInput: false,
    arrivalPicker: false,
    departurePicker: false,
    subEventStartTime: "",
    subEventEndTime: "",
    errorDialog: false,
    valid: true,
    groupSizeRules: [v => !!v || "This field is required", v =>
          (v && v <= 8) ||
          "The group is to big to book all the events", v =>
          (v && v > 0) ||
          "Your group can not be 0 or a negative number"],
    textRule: [v => !!v || "Field is required"],
    numberRule: [v => (v => 0 && v < 10) || "1-9 allowed"],
    menu: false,
    menu2: false,
    unformattedStartDate: null,
    unformattedEndDate: null,
    startDateFormatted: null,
    endDateFormatted: null,
    typesOfTrans: [],

    activities: []
  }),
  created() {
    this._tripForm.groupSize = '';
    this._tripForm.ArrivalTime = '';
    this._tripForm.DepartureTime = '';
    this._tripForm.name = '';
    this.formattedEndDate = null;
    this.formattedStartDate = null;
  },
  mounted() {
    this.getTransportationTypesForEvent();

    Object.size = function(obj) {
      var size = 0,
        key;
      for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
      }
      return size;
    };

    if (Object.size(this._tripForm.activities) == 0) {
      this.activities = this._tripForm.chosenTheme.Children;
    } else {
      this.activities = this._tripForm.activities;
    }

    this.unformattedStartDate = this.formatDate(this._tripForm.startDate);
    this.unformattedEndDate = this.formatDate(this._tripForm.endDate);
  },

  methods: {
    checkTheData(){
      if(this._tripForm.groupSize < 1){
        this.disableButton = true;
      }
      else {
        if(this.formattedStartDate > this.formattedEndDate){
          this.disableButton = true;
        }
        else {
          if(this._tripForm.groupSize != '' && this._tripForm.ArrivalTime != '' && this._tripForm.DepartureTime != ''
            && this._tripForm.name != '' && this._tripForm.transportName != '' && this.formattedEndDate != null && this.formattedStartDate != null){
            this.disableButton = false;
          }
          else {
            this.disableButton = true;
          }
        }
      }
    },
    getTransportationTypesForEvent() {
      const payload = {
        EventId: this._tripForm.chosenTheme.EventId,
        FunctionId: "EventFunctionLibrary::getTransportationTypesForEvent"
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getTransportationTypesForEvent was successful",
            response
          );
          delete response.data.ErrorMsg;
          for (const [key, value] of Object.entries(response.data)) {
            this.typesOfTrans.push(value);
          }
          this.typesOfTrans.push({ Description: "Walking", Tag: 0 });
          this.typesOfTrans.push({ Description: "Car", Tag: 1 });
          this.typesOfTrans.push({ Description: "Bicycle", Tag: 2 });
          this._tripForm.transportId = 0;
          this._tripForm.transportName = "Walking";
        },
        e => {
          console.log(
            "The generic call getTransportationTypesForEvent was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload
      );
    },

    formatDate(date) {
    if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },

    setChosenDetails() {
      if (this.$refs.form.validate()) {
      let today = new Date();
      let date = today.getDate()+'-'+(today.getMonth()+1)+'-'+ today.getFullYear();
      let day = this.formattedStartDate
      let day2 = this.formattedEndDate
      let time = Number(today.getHours());
      let min = today.getMinutes();
      let minutes = String(min).length
        if(minutes !== 2){
          time = Number(time + '0' + min)
        }
        else {
          time = Number(time + '' + min)
        }
      let arrival = Number(this._tripForm.ArrivalTime.replace(':',''))
      let departure = Number(this._tripForm.DepartureTime.replace(':',''))
      let dayInString = today.toLocaleDateString;

      // if(day > day2){
      //   this.wrongTimeInput = true;
      //   this.errorText = 1
      //   return
      // }

      // else if (departure < arrival) {

      //   this.wrongTimeInput = true
        // this.errorText = 2
      //   return
      // }
        console.log(
          /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(
            this._tripForm.ArrivalTime
          ) +
            " - " +
            /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(
              this._tripForm.DepartureTime
            )
        );

        //add the : to the time
        if (this._tripForm.ArrivalTime.charAt(2) !== ":") {
          this._tripForm.ArrivalTime =
            this._tripForm.ArrivalTime.slice(0, 2) +
            ":" +
            this._tripForm.ArrivalTime.slice(2, 4);
        }

        if (this._tripForm.DepartureTime.charAt(2) !== ":") {
          this._tripForm.DepartureTime =
            this._tripForm.DepartureTime.slice(0, 2) +
            ":" +
            this._tripForm.DepartureTime.slice(2, 4);
        } else {
        }

        //check if time input is correct
        if (
          !/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(this._tripForm.ArrivalTime)
        ) {
          this.wrongTimeInput = true;
          return;
        }
        if (
          !/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(
            this._tripForm.DepartureTime
          )
        ) {
          this.wrongTimeInput = true;
          return;
        }

        if(Date.parse(this.unformattedStartDate) > Date.parse(this.unformattedEndDate)) {
          this.wrongTimeInput = true;
          return;
        } else {
        }

        this._tripForm.startDate = this.formattedStartDate;
        this._tripForm.endDate = this.formattedEndDate;

        if (
          this._tripForm.startDate == this._tripForm.endDate &&
          this._tripForm.ArrivalTime >= this._tripForm.DepartureTime
        ) {
          this.errorText = 2
          this.wrongTimeInput = true;
          // console.log("WRONGTIME: " + this._tripForm.startDate + " - " + this._tripForm.endDate + " | " +
          // this._tripForm.ArrivalTime +  " - "  + this._tripForm.DepartureTime)
          return;
        }

        this.$store.commit("setTripFormStartDate", this._tripForm.startDate);
        this.$store.commit("setTripFormEndDate", this._tripForm.endDate);

        this.$store.commit(
          "setTripFormArrivalTime",
          this._tripForm.ArrivalTime
        );
        this.$store.commit(
          "setTripFormDepartureTime",
          this._tripForm.DepartureTime
        );

        this.$store.commit("setTripFormGroupSize", this._tripForm.groupSize);
        this.$emit("createTrip");
      } else {
        this.errorDialog = true;
      }
    },

    previousStep() {
      this._tripForm.activities = [];
      this._tripForm.ArrivalTime = "";
      this._tripForm.DepartureTime = "";
      this._tripForm.startDate = null;
      this._tripForm.endDate = null;
      this._tripForm.groupSize = 1;
      this.$store.commit("setWebStepId", this.$store.getters.getWebStepId - 1);
    },
    goHome() {
      // this._tripForm.activities = [];
      // this._tripForm.ArrivalTime = "";
      // this._tripForm.DepartureTime = "";
      // this._tripForm.startDate = null;
      // this._tripForm.endDate = null;
      // this._tripForm.groupSize = 1;

      this.$router.push({
        name: "Homepage",
        params: {
          account_id: this.$store.getters.getRegion
        }
      });

      this.$store.commit("setWebStepId", 1);
    },
  }
};
</script>
<style>
.layoutTest {
  margin-top: -2em !important;
}

.m1 {
  margin-bottom: 1em !important;
}
</style>
